import ReactModal from "react-modal";
import styled from "styled-components";

export const Container = styled.form`
  height: 700px;
  overflow: auto;
  .modal-logo {
    background-color: #e6e6e6;
    border: 4px solid white;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    display: flex;
    width: 133px;
    height: 133px;
  }
  .logo-main {
    display: flex;
    justify-content: center;
    margin-top: 1.6rem;
    position: relative;
  }
  .model-container {
    margin-top: 50px;
    h1 {
      font-weight: 600;
    }
  }
  .model-header {
    background-color: #e6e6e6;
    height: 126px;
    width: 100%;
    border-radius: 20px 20px 0px 0px;
  }
  .upload-cam {
    position: absolute;
    left: 360px;
    top: 81px;
    border-radius: 200px;
    @media (max-width: 990px) {
      left: 330px;
    }
    @media (max-width: 768px) {
      left: 285px;
    }
    @media (max-width: 546px) {
      display: none;
      left: 255px;
    }
  }
  .upload-main {
    display: flex;
    gap: 20px;
    justify-content: end;
    align-items: center;
    position: absolute;
    right: 20px;
    top: 90px;
    

  }
  .upload-icon {
    width: 20px;
  }
  .model-title {
    display: flex;
    justify-content: space-between;
    padding: 2rem;
    border-radius: 1rem 1rem 0 0;
    position: relative;
    .close-button {
      z-index: 5;
      display: flex;
      justify-content: flex-end;
      position: absolute;
      top: 1.5rem;
      right: 1.5rem;
    }
    .tag-line-banner {
      z-index: 5;
      position: absolute;
      right: 40%;
      top: 1.5rem;
      color: #808d9e;
      font-weight: 600;
      font-size: 15px;
    }
  }

  .add-retailer-container {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    margin-top: 1.5rem;
    width: 100%;
    padding: 0 2rem;

    .image-container {
      width: 100%;
    }

    .retailer-input {
      width: 48%;
      display: flex;
      flex-direction: column;
      gap: 0.8rem;
      label {
        font-size: 1.5rem;
        color: #333;
        font-weight: 500;
      }
    }
    input {
      height: 5.2rem;
      background-color: var(--light-gray);
      border-radius: 5px;
      outline-style: none;
      border: none;
    }
    .phone-input {
      .PhoneInputInput {
        height: 5.2rem;
        background-color: var(--light-gray);
        border-radius: 5px;
        outline-style: none;
        border: none;
        padding: 0 1rem;
        width: 100%;
      }
      .PhoneInputCountryIcon {
        width: 2rem;
        height: 1.5rem;
      }
      .PhoneInputCountrySelect {
        height: 5.2rem;
        background-color: var(--light-gray);
        border: none;
        border-radius: 5px 0 0 5px;
        outline-style: none;
        padding: 0 0.5rem;
      }
    }
    .image-input {
      //   height: 200px;
    }
  }
  .submit-btn{
     height: 5rem;
  width: 40%;
  border-radius: 5px;
  background-color: var(--primary);
  color:  white;
  cursor: pointer;
  text-align: center;
  align-items:center;
  display: flex;
  padding: 0.5rem 1rem;
  justify-content:center;
   @media (max-width: 710px) {
        width: 50%;
    }
   @media (max-width: 510px) {
        width: 80%;
    }
  }
`;

export const ImageContainer = styled.div`
  .modal-retailers {
    over-flow-y: auto;
    // overflow-y: hidden;
  }
`;
export const StyledReactModal = styled(ReactModal)`
      position: absolute;
      top: 50%;
      left: 50%;
      right: auto;
      bottom: auto;
      margin: auto;
      transform: translate(-50%, -50%);
      font-size: 2rem;
      width: 68.5rem;
  
      border-radius: 2rem !important;
      background-color: white;
      @media (max-width:  768px) {
        width: 90%;
  
      }

`;
